<template>
  <div class="flex items-center justify-between">
    <div class="blog_doctor_image flex items-center gap-[0.8rem]">
      <BaseDoctorImage :image="doctorImage || ''" :name="doctorName" size="3.2rem" />
      <h3 :class="[additionalClass, 'text-left md:text-[10px] sm:text-[8.4px] sm:text-base']">{{$t('By')}} {{doctorName}}</h3>
    </div>

    <div v-if="date" class="text-[color:var(--black)] text-base">
      <span>{{date}}</span>
    </div>
  </div>
</template>

<script>
import BaseDoctorImage from '@/components/doctor/doctorImage.vue';

export default {
  name: 'DoctorImage',
  components: {
    BaseDoctorImage,
  },
  props: {
    doctorImage: {
      type: String,
      required: false,
      default: ''
    },
    doctorName: {
      type: String,
      required: true
    },
    date: {
      type: String,
      required: false
    },
    additionalClass: {
      type: String,
      required: false,
      default: 'text-white'
    }
  }
};
</script>

<style scoped>

.blog_doctor_image {
  justify-content: start;
}

</style>
